<template>
  <div>
    <Row
      :gutter="8"
      style="margin: 0px 0 0 0; width: 100%"
      v-if="menus && menus.length > 0"
    >
      <Menu
        mode="horizontal"
        :active-name="menu_name"
        @on-select="selectMenu"
        style="width: 100%"
      >
        <div
          v-for="(v, k) in menus"
          style="display: inline-block"
          :key="k"
          v-auth="v.auth"
        >
          <MenuItem
            :name="v.name"
            @click="v.onClick"
            v-show="v.show === true ? false : true"
          >
            <Badge
              :overflow-count="10000000"
              v-if="v.badge && v.badge.count"
              :count="v.badge.count"
              :offset="[18, -3]"
            >
              {{ v.label }}
            </Badge>
            <span v-if="!(v.badge && v.badge.count)">
              {{ v.label }}
            </span>
          </MenuItem>
        </div>
      </Menu>
    </Row>
    <Form :label-width="80" style="width: 500px; margin-top: 20px">
      <!-- <h4>流程设置</h4> -->
      <FormItem label="审核采购人:">
        <Select
          v-model="examine"
          multiple
          placeholder="选择审核采购人"
          @on-change="getexamine"
        >
          <Option v-for="item in arr" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </FormItem>
      <!--  <FormItem label="采购人:">
        <Select v-model="procure" placeholder="选择采购人">
          <Option v-for="item in arr" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </FormItem> -->
      <FormItem>
        <Button type="primary" @click="add">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
let customerId = window.localStorage.getItem("customerId");
export default {
  components: {},
  data() {
    return {
      url: {
        add: "/admin/system/flowPath/add",
      },
      arr: [],
      id: "",
      examine: "",
      examineId: "",
      menus: [
        // {
        //   label: "资产类型",
        //   name: "deviceClass_list",
        //   auth: "system/deviceClass/index",
        // },
        // {
        //   label: "型号库",
        //   name: "deviceType_list",
        //   auth: "",
        // },
        // {
        //   label: "物资分类",
        //   name: "consumablesClass_list",
        //   auth: "system/consumablesClass/index",
        //   show: !(Number(customerId) === 0),
        // },
        {
          label: "领用流程",
          name: "approvalProcess_list",
          auth: "",
        },
        {
          label: "采购流程",
          name: "ProcessIndex",
          auth: "system/processIndex/index",
          show: !(Number(customerId) === 0),
        },
      ],
      menu_name: "",
    };
  },
  created() {
    this.loadLevelData();
    this.getflowPath();
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
  },
  methods: {
    getexamine(val) {
      if (val != []) {
        this.examineId = val.join(",");
      }
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    loadLevelData() {
      let q = {};
      $utils.api.load("/admin/system/user/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.label = element.nickName;
            dropList.push(xx);
          }
          this.arr = dropList;
        }
      });
    },
    getflowPath() {
      $utils.api.load("/admin/system/flowPath/get").then((res) => {
        if (res.code == 200) {
          let str = res.data.examineUser;
          let arr = str.split(",").map((item) => item.trim());
          this.examine = arr.map(Number);
          this.id = res.data.id;
        }
      });
    },
    add() {
      if (this.examineId == "") {
        $utils.toast.error("请选择审核采购人");
      }
      let q = {
        examineUser: this.examineId,
        workType: 1,
        id: this.id,
      };
      $utils.api.load("/admin/system/flowPath/add", q, "post").then((res) => {
        if (res.code == 200) {
          $utils.toast.success("提交成功");
          this.$Modal.remove();
          setTimeout(function () {
            $utils.url.go(0);
          }, 2000);
        }
      });
    },
  },
};
</script>
<style scoped>
h4 {
  margin-bottom: 10px;
}
</style>
